import { useMemo } from "react";
import {
  Bar,
  XAxis,
  YAxis,
  LabelList,
  CartesianGrid,
  ResponsiveContainer,
  BarChart as ReBarChart,
} from "recharts";

import { Tooltip } from "./Tooltip";
import { capitalize } from "../../services/utils";
import { TooltipContent } from "./TooltipContent";

const renderCustomizedLabel = ({ x, type, name }) => {
  const offset = type === "power_revenue" ? 75 : 30;
  return (
    <text x={x + 40} y={offset} fill="#212121" fontSize={10}>
      {name}
    </text>
  );
};

export const NOIBarChart = ({ chartData, bars, height, barSize, defaultLabel }) => {
  const hasAnyValue = useMemo(() => {
    const result = Object.values(chartData.data[0]).every((value) => value == 0);
    return !result;
  }, [chartData]);

  return (
    <ResponsiveContainer width="100%" height={height || 200}>
      <ReBarChart data={chartData.data} barSize={barSize || 15}>
        <CartesianGrid vertical={false} strokeDasharray="5 2" />
        <YAxis tickCount={3} hide={true} />
        <XAxis
          axisLine={false}
          tickLine={false}
          hide={true}
          dataKey="name"
          padding={{ right: 140 }}
        />
        {hasAnyValue && (
          <Tooltip
            chartData={chartData.data}
            content={<TooltipContent defaultLabel={defaultLabel} />}
          />
        )}
        <Bar stackId="a" dataKey={bars[1].dataKey} fill={bars[1].fill} unit={bars[1].unit}>
          <LabelList
            dataKey={bars[1].dataKey}
            content={renderCustomizedLabel}
            type="existing_noi"
            name={chartData.fields.length > 1 ? capitalize(chartData.fields[1]) : null}
          />
        </Bar>
        <Bar stackId="a" dataKey={bars[0].dataKey} fill={bars[0].fill} unit={bars[0].unit}>
          <LabelList
            dataKey={bars[0].dataKey}
            content={renderCustomizedLabel}
            type="power_revenue"
            name={chartData.fields.length ? capitalize(chartData.fields[0]) : null}
          />
        </Bar>
      </ReBarChart>
    </ResponsiveContainer>
  );
};
